import { Navigate, type RouteObject } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

import { LineageInternalGuard } from "./lineage-internal-guard";

const Layout = lazyNamed(() => import("./layout"), "Layout");
const Partitions = lazyNamed(() => import("./partitions"), "Partitions");
const Performance = lazyNamed(() => import("./performance"), "Performance");
const Usage = lazyNamed(() => import("./usage"), "Usage");

export const routes: Array<RouteObject> = [
  {
    path: "lineage/*",
    element: <LineageInternalGuard />,
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        path: "",
        element: <Layout />,
        spacesAccess: "hidden-from-limited-view",
        children: [
          {
            index: true,
            element: <Navigate to="partitions" replace />,
            spacesAccess: "hidden-from-limited-view",
          },
          {
            path: "partitions",
            element: <Partitions />,
            spacesAccess: "hidden-from-limited-view",
          },
          {
            path: "performance",
            element: <Performance />,
            spacesAccess: "hidden-from-limited-view",
          },
          {
            path: "usage",
            element: <Usage />,
            spacesAccess: "hidden-from-limited-view",
          },
        ],
      },
    ],
  },
];
